<template>
  <div class="container">
    <van-tabs
      v-model="orderStatusId"
      lazy-render
      @change="onChange"
      style="z-index: 2"
    >
      <van-tab
        v-for="tab in orderStatusList"
        :key="tab.name"
        :name="tab.name"
        :title="tab.title"
      ></van-tab>
    </van-tabs>
    <div class="noOrders" v-if="orderList.length == 0">
      <div class="imageEmptyStock">
        <img src="../../../assets/images/orderEmpty.png" alt />
      </div>
      <div v-if="!firstLoading">你还没有订单哦...</div>
      <van-loading v-else type="spinner" />
    </div>
    <div
      v-if="orderList.length > 0"
      :class="AgentIsShow == true ? 'scrollAgent' : 'scroll'"
    >
      <!-- <van-pull-refresh
        v-model="refreshing"
        @refresh="onRefresh"
        style="height: calc(100% - 24.2vw); overflow: auto"
      > -->
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="到底啦~"
        @load="onLoad"
        :immediate-check="false"
        class="cardList"
      >
        <!-- <van-panel
            :title="'订单编号：' + order.orderId"
            :status="getChineseStatus(order.orderStatus)"
            style="border-bottom: 5px solid #f8f8f8"
          > -->
        <van-panel
          v-for="order in orderList"
          :key="order.id"
          style="border-bottom: 5px solid #f8f8f8"
        >
          <template slot="header">
            <div class="orderBottom">
              <div class="flex-between">
                <div class="orderHeaderTop">
                  <div class="orderIcon" v-if="order.orderClass == 1">
                    <svg class="orderIcon" aria-hidden="true">
                      <use xlink:href="#icon-daimaitubiao"></use>
                    </svg>
                  </div>
                  <div>
                    {{ "订单编号：" + order.orderId }}
                  </div>
                </div>
                <div class="orderHeaderTop panelStatus">
                  {{ getChineseStatus(order.orderStatus) }}
                </div>
              </div>

              <!-- <div>
                  {{ getChineseStatus(order.orderStatus) }}
                </div> -->
              <div class="flex-between">
                <div class="orderHeaderTop">
                  {{ order.orderTime }}
                </div>
                <div
                  v-if="
                    order.orderStatus == 'submitted' && order.cancelTime > 0
                  "
                  class="orderHeaderTop"
                >
                  订单将于<span class="red">{{ order.cancelTime }}</span>
                  分钟后自动取消
                </div>
                <div
                  v-if="
                    order.orderStatus == 'submitted' && order.cancelTime < 0
                  "
                  class="orderHeaderTop"
                >
                  <span class="red">取消中</span>
                </div>
              </div>

              <!-- <div v-else class="panelHeader">订单商品</div> -->
            </div>
          </template>
          <div @click="onOrderClick(order.orderId)">
            <div
              v-for="(item, index) in order.orderItems"
              :key="index"
              class="cardItem"
            >
              <van-card
                :num="item.quantity"
                :desc="item.itemSpecs"
                :title="item.itemName"
                :thumb="item.picture"
                class="card_shop"
              ></van-card>
            </div>
            <van-panel v-if="order.orderGiftItems.length !== 0" :border="false">
              <template slot="header">
                <div class="flex-between orderBottomGift">
                  <!-- 绑定用户可以有新人大礼包 -->
                  <!-- win 根据返回类型判断是否展示新人大礼包价格 -->
                  <div
                    class="panelHeader red"
                    v-if="order.orderGiftItems[0].goodsType == 2"
                  >
                    新人首单大礼包
                  </div>
                  <!-- 店员店长可以有赠品 -->
                  <div
                    class="panelHeader red"
                    v-if="order.orderGiftItems[0].goodsType == 1"
                  >
                    赠品
                  </div>
                  <!-- 活动满赠 -->
                  <div
                    class="panelHeaderType"
                    v-if="order.orderGiftItems[0].goodsType == 3"
                  >
                    赠品
                  </div>
                </div>
              </template>
              <van-card
                v-for="item in order.orderGiftItems"
                :key="item.goodsCode"
                :num="item.quantity"
                :title="item.itemName"
                :desc="item.itemSpecs"
                :thumb="item.picture"
                class="shopCard"
              />
            </van-panel>
          </div>
          <div slot="footer" style="display: flex">
            <div class="orderlist_foot">
              <div class="ActualAmount">
                实付金额:
                <span style="color: #ee0a24">
                  ￥{{ formatPrice(order.orderPrice) }}
                </span>
              </div>
              <!-- win包含新人大礼包等所有件数 -->
              <div class="order_sum" v-if="order.orderGiftItems.length !== 0">
                共{{
                  [...order.orderItems, ...order.orderGiftItems]
                    .map((val) => val.quantity)
                    .reduce((prev, curr) => {
                      return prev + curr;
                    }, 0)
                }}件
              </div>
              <div class="order_sum" v-else>
                共{{
                  order.orderItems.reduce((prev, curr) => {
                    return prev + curr.quantity;
                  }, 0)
                }}件
              </div>
            </div>
            <button
              class="cancel"
              @click="onCancel(order.orderId)"
              v-if="order.orderStatus == 'submitted'"
            >
              取消
            </button>
            <button
              class="pay_button _button"
              @click="onPay(order.orderId)"
              v-if="order.orderStatus == 'submitted'"
            >
              去付款
            </button>
            <button
              class="cancel"
              @click="onRefund(order)"
              v-if="
                (order.orderStatus == 'paid' &&
                  order.orderType !== 4 &&
                  order.canRefundNow !== 2) ||
                (order.orderStatus == 'shipped' &&
                  order.orderType !== 4 &&
                  order.canRefundNow !== 2)
              "
            >
              退款
            </button>
            <button
              class="look_button _button"
              @click="onOrderClick(order.orderId)"
              v-if="
                order.orderStatus == 'paid' || order.orderStatus == 'shipped'
              "
            >
              查看订单
            </button>
            <van-popup v-model="show" class="pagePopup">
              <div class="group">
                <van-form>
                  <van-field
                    v-model="form.expressName"
                    placeholder="请输入快递名称"
                    required
                    clearable
                    label="快递名称"
                    :value="form.expressName"
                  ></van-field>
                  <van-field
                    v-model="form.expressNo"
                    placeholder="请输入快递单号"
                    required
                    clearable
                    label="快递单号"
                    :value="form.expressNo"
                  ></van-field>
                </van-form>
              </div>
              <div
                class="buttonText"
                @click="onSubmit(form, order.orderId, order.orderStatus)"
              >
                <button class="button">提交</button>
              </div>
            </van-popup>
          </div>
        </van-panel>
      </van-list>
      <!-- </van-pull-refresh> -->
    </div>
    <van-overlay :show="isLoading">
      <div class="wrapper">
        <loading v-if="isLoading == true"></loading>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import {
  Tab,
  Tabs,
  Card,
  Button,
  Panel,
  Dialog,
  Toast,
  List,
  PullRefresh,
  Loading,
  Notify,
  Form,
  Field,
  Overlay,
  Popup,
} from "vant";
import service from "../../api/order/index";
import servicePay from "../../api/payment/wxpay/index";
import { wxPay } from "../../util/wxHelper";
// import { parseTime } from "../../util/date";
import loading from "../../components/loading/loading";
import { mapGetters } from "vuex";
export default {
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Card.name]: Card,
    [Button.name]: Button,
    [Panel.name]: Panel,
    [Dialog.Component.name]: Dialog.Component,
    [Toast.name]: Toast,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Loading.name]: Loading,
    [Form.name]: Form,
    [Field.name]: Field,
    [Popup.name]: Popup,
    [Overlay.name]: Overlay,
    loading,
  },
  data() {
    return {
      // orderListHeight: 0,
      cancelTime: 5,
      Timer: 0,
      isLoading: true, //loading状态
      form: {
        expressName: "",
        expressNo: "",
      },
      show: false,
      orderStatusId: "",
      orderList: [],
      orderStatusList: [
        { name: "", title: "全部" },
        { name: "1", title: "待付款" },
        { name: "2", title: "待发货" },
        { name: "3", title: "待收货" },
      ],
      noDate: false, //这是一个判断是否加载的开关
      arr: [],
      page: 1,
      pageSize: 10,
      reachBottom: false,
      loading: false,
      finished: false,
      // refreshing: false,
      orderStatusText: "",
      totalOrder: 0,
      orderStatusTextChinese: "",
      firstLoading: true,
      orderTimer: null,
    };
  },
  watch: {
    // 倒计时
    minute: {
      handler(newVal) {
        this.num(newVal);
      },
    },
  },
  computed: {
    ...mapGetters(["userInfo", "agentShow"]),
    AgentIsShow() {
      return this.agentShow == null ? false : this.agentShow.isShow;
    },
    // orderNumber () {
    //   console.log(this.orderList, 'this.order')
    //   if (this.orderList.orderGiftItems && this.orderList.orderGiftItems.length !== 0) {
    //     const itemQuantities = [...this.orderList.orderItems, ...this.orderList.orderGiftItems]
    //       .map(item => item.quantity)
    //       .reduce((prev, curr) => prev + curr, 0);
    //     return itemQuantities
    //   } else {
    //     const n = this.orderList.map(v => {
    //       console.log(v,'vvvvvvvv')
    //       v.orderItems.reduce((p, c) => {
    //         return p + c.quantity;
    //       }, 0)
    //     })
    //     return n
    //   }
    // },
    // 倒计时
    minute: function () {
      return this.num(this.minutes);
    },
  },
  mounted() {
    if (localStorage.getItem("backOrderId")) {
      if (JSON.parse(localStorage.getItem("backOrderId")) == "all") {
        this.orderStatusId = "";
      } else {
        this.orderStatusId = JSON.parse(localStorage.getItem("backOrderId"));
      }
    } else {
      this.orderStatusId = this.$route.query.orderStatusId;
    }
    this.init();
  },
  beforeRouteLeave(to, from, next) {
    console.log("我离开了");
    if (this.orderTimer) {
      clearInterval(this.orderTimer);
    }
    next();
  },
  destroyed() {
    localStorage.removeItem("backOrderId");
  },
  methods: {
    num(n) {
      // 倒计时结束重新刷新页面
      if (this.minutes === 0) {
        this.init(this.$route.query.id);
      }
    },
    // 倒计时

    timer() {
      this.orderList.map((i, v) => {
        if (i.orderStatus == "submitted") {
          console.log("进来了", v);
          // i.minutes = 5;
          // i.cancelTime = Math.ceil(i.cancelTime / 60);
          var _this = this;
          this.orderTimer = setInterval(function () {
            if (i.cancelTime > 0) {
              i.cancelTime--;
              // console.log(i.cancelTime)
            } else {
              if (i.cancelTime < 0) {
                console.log("时间超过6分钟，不在反复调取数据");
              } else {
                console.log("重新加载数据");
                clearInterval(this.orderTimer);
                _this.init(_this.$route.query.id);
              }
            }
          }, 60000);
        }
      });
    },
    formatPrice(price) {
      if (price >= 1) {
        return price.toFixed(2);
      } else {
        return price;
      }
    },
    onLoad() {
      this.page++;
      this.getList().then((orderList) => {
        orderList.items.map((i, v) => {
          if (i.orderStatus == "submitted") {
            i.minutes = JSON.parse(JSON.stringify(i.cancelTime));
            i.cancelTime = Math.ceil(i.cancelTime / 60);
            console.log(
              this.orderList,
              i.cancelTime,
              i.minutes,
              "i.cancelTime"
            );
          }
        });
        this.orderList = this.orderList.concat(orderList.items);

        this.loading = false;
        if (orderList.totalCount <= this.orderList.length) {
          this.finished = true;
        }
      });
    },
    init() {
      this.page = 1;
      this.firstLoading = true;
      this.loading = false;
      this.getList()
        .then((orderList) => {
          setTimeout(() => {
            this.isLoading = false;
          }, 500);
          if (orderList.items.length > 0) {
            orderList.items.map((i, v) => {
              if (i.orderStatus == "submitted") {
                i.minutes = JSON.parse(JSON.stringify(i.cancelTime));
                i.cancelTime = Math.ceil(i.cancelTime / 60);
              }
            });
          }
          this.orderList = orderList.items;
          this.timer();
          this.finished = false;
          this.firstLoading = false;
          if (orderList.totalCount <= 10) {
            this.finished = true;
            this.loading = false;
          }
        })
        .catch((err) => {
          this.isLoading = false;
        });
    },
    // onRefresh() {
    //   // 清空列表数据
    //   this.page = 1;
    //   this.finished = false;
    //   // 重新加载数据
    //   // 将 loading 设置为 true，表示处于加载状态
    //   this.loading = true;
    //   this.orderList = [];
    //   this.isLoading = true;
    //   this.getList().then((orderList) => {
    //     this.isLoading = false;
    //     this.orderList = orderList.items;
    //     if (orderList.items.length < 4) {
    //       this.finished = true;
    //       this.loading = false;
    //     }
    //     //
    //     this.refreshing = true;
    //     this.onLoad();
    //   });
    // },

    onOrderClick(orderId) {
      if (this.orderStatusId == "") {
        this.orderStatusId = "all";
      }
      this.$router.push({
        name: "orderDetail",
        query: { id: orderId, orderStatusId: this.orderStatusId },
      });
    },
    onChange(orderStatusId) {
      this.isLoading = true;
      this.orderStatusId = orderStatusId;
      this.orderList = [];
      this.page = 1;
      this.finished = false;
      this.firstLoading = true;
      this.loading = true;
      this.getList()
        .then((orderList) => {
          setTimeout(() => {
            this.isLoading = false;
          }, 500);
          if (orderList.items.length > 0) {
            orderList.items.map((i, v) => {
              if (i.orderStatus == "submitted") {
                i.minutes = JSON.parse(JSON.stringify(i.cancelTime));
                i.cancelTime = Math.ceil(i.cancelTime / 60);
                console.log(
                  this.orderList,
                  i.cancelTime,
                  i.minutes,
                  "i.cancelTime"
                );
              }
            });
          }
          this.orderList = orderList.items;
          this.timer();
          if (orderList.totalCount <= this.orderList.length) {
            this.finished = true;
          } else {
            this.onLoad();
          }
          this.timer();
          this.firstLoading = false;
          this.loading = false;
        })
        .catch((err) => {
          this.isLoading = false;
        });
    },
    getChineseStatus(orderStatusText) {
      switch (orderStatusText) {
        case "submitted":
          return "待支付";
        case "paid":
          return "已支付";
        case "shipped":
          return "已发货";
        case "refund":
          return "申请退款";
        case "refunded":
          return "退款成功";
        case "completed":
          return "订单完成";
        case "cancelled":
          return "已取消";
        default:
          break;
      }
    },
    onRefund(item) {
      console.log(item, "退款");
      // let payTime = "" + item.payTime;
      // // 截取到前面的日期
      // let timer = payTime.substring(0, 10);
      // var startOrderTime = new Date(timer.replace(/-/g, "/"));
      // var today = new Date();
      // var today_time = parseTime(today);
      // var nowTime = new Date(today_time.replace(/-/g, "/"));
      // 超过当天日期 要填写单号 canRefundNow  0 跳转退款页面 1 立即退款
      if (item.canRefundNow == 0) {
        this.$router.push({
          name: "refund",
          query: {
            orderId: item.orderId,
          },
        });
        return;
      }
      this.isLoading = true;
      if (item.canRefundNow == 1) {
        Dialog.confirm({
          title: "申请退款",
          message: "确认申请退款",
        })
          .then(() => {
            Toast.loading({ message: "加载中...", forbidClick: true });
            service.refundDay(item.orderId).then((res) => {
              if (res.statusCode == 200) {
                Toast("申请成功，请耐心等待退款通知...");
                setTimeout(() => {
                  this.isLoading = false;
                }, 500);
                this.init();
                this.$router.push("myorder?orderStatusId=");
              } else {
                setTimeout(() => {
                  this.isLoading = false;
                }, 500);
                if (
                  res.errors == "订单不正确" ||
                  res.errors == "已超出退款时间" ||
                  res.errors == "购买库存无法直接退款"
                ) {
                  Toast(res.errors);
                } else {
                  Toast("申请失败");
                }
              }
            });
          })
          .catch((err)=>{
            this.isLoading = false;
          });
      }
    },
    onSubmit(form, orderId, orderStatus) {
      if (orderStatus == "shipped") {
        if (form.expressName == "") {
          Notify({ type: "danger", message: "请输入快递名称" });
          return;
        }

        if (form.expressNo == "") {
          Notify({ type: "danger", message: "请输入快递单号" });
          return;
        }
      }

      service.refund(form, orderId).then((res) => {
        if (res.statusCode == 200) {
          Toast.success("提交成功");
        } else {
          Toast(res.errors);
          // Notify({ type: "danger", message: res.errors });
        }
        this.show = false;
      });
    },
    onCancel(orderId) {
      Dialog.confirm({
        message: "确认取消订单么",
      })
        .then(() => {
          Toast.loading({ message: "加载中...", forbidClick: true });
          service.cancel(orderId).then((res) => {
            if (res.statusCode == 200) {
              Toast.success("已取消");
            } else {
              // Notify({ type: "danger", message: res.errors });
              Toast(res.errors);
            }
            this.init();
          });
        })
        .catch();
    },

    onPay(orderId) {
      // 是否需要判断代买状态

      this.isLoading = true;
      service.checkOrderExpire(orderId).then((res) => {
        if (res.statusCode == 200) {
          if (res.data) {
            // 如果为true
            this.unifiedOrderPay(orderId);
            this.isLoading = false;
          } else {
            Toast("订单异常无法支付");
            this.isLoading = false;
          }
        } else {
          this.isLoading = false;
          Toast(res.errors);
        }
      });
    },
    unifiedOrderPay(orderId) {
      this.isLoading = true;
      servicePay
        .unifiedOrder(orderId, this.userInfo.openId)
        .then((response) => {
          this.isLoading = false;
          wxPay(response.data)
            .then((res) => {
              this.$router.push({
                name: "payResult",
                query: { id: orderId, status: true },
              });
            })
            .catch((err) => {
              this.isLoading = false;
              // Notify({ type: "danger", message: res.errMsg });
              // Toast(err);
              this.$router.push({
                name: "payResult",
                query: { id: orderId, status: false },
              });
            });
        })
        .catch();
    },
    getList() {
      return new Promise((resolve, reject) => {
        var dataStr = this.orderStatusId;
        var dataStrArr = dataStr.split(",");
        var dataIntArr = [];
        if (this.orderStatusId.length == 0 && this.orderStatusId == "") {
          console.log("test");
        } else {
          dataStrArr.forEach(function (data, index, arr) {
            dataIntArr.push(parseInt(data));
          });
        }
        service
          .list(dataIntArr, this.page, this.pageSize)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject();
          });
      });
    },
  },
};
</script>
<style lang="less" scoped>
@deep: ~">>>";

.pagePopup {
  width: 72vw;
  padding: 4vw 1vw 6vw 4vw;
  border-radius: 3vw;
}

.buttonText .button {
  width: 190px;
  height: 30px;
  font-size: 14px;
}

.container {
  position: fixed;
  height: calc(100% - 0.7vw);
  // min-height: 100vh;
  overflow-y: scroll;

  .orderBottomGift {
    // border-bottom: 1px solid #f7f7f7;
    // height: 10vw;
    margin: 16px 16px 0;
  }

  .van-tabs {
    position: fixed;
    width: 100%;
    //代买活动修改
    // top: 0;
    border-bottom: 1px solid #f7f7f7;
  }

  @{deep}.van-tabs--line .van-tabs__wrap {
    height: 13vw;
  }

  @{deep}.van-tabs__content--animated {
    height: 100%;
  }

  @{deep}.van-tab__pane,
  @{deep}.van-tab__pane-wrapper {
    height: 100%;
  }

  // position: fixed;
  // height: 100%;
  width: 100%;
  background: #f8f8f8;

  .orderImage {
    width: 80vw;
    margin: auto;
  }

  .scroll {
    border-top: 1vw solid #f7f7f7;
    // background: #f4f4f4;
    // height: calc(100% - -11.3vw);
    margin-top: 50px;
    // overflow-y: scroll;
  }
  .scrollAgent {
    border-top: 1vw solid #f7f7f7;
    margin-top: 50px;
    margin-bottom: 48px;
  }

  .cancel {
    border: 0;
    background: #fff;
    font-size: 3.4vw;
    color: #333;
  }

  ._button {
    border: 0;
    font-size: 3vw;
    color: #fff;
    border-radius: 5px;
    margin-left: 2vw;
    padding: 0 1px;
  }

  .pay_button {
    background: #ee0a24;
    width: 16vw;
  }

  .look_button {
    background: #ff6274;
    width: 19vw;
  }

  .order_sum {
    color: #929292;
  }
}

.flex-between {
  width: auto;
  // font-size: 14px;
}

.orderBottom {
  height: 60px;
  font-size: 13px;
}

.orderHeaderTop {
  margin-top: 8px;
  display: flex;
  height: 20px;
  align-items: center;
}
.panelHeaderType {
  color: rgba(51, 51, 51, 1);
}
.van-cell--borderless::after,
.van-cell:last-child::after {
  display: block;
}

.van-cell {
  justify-content: space-between;
}

.van-cell__title {
  flex: none;
  color: #92909a;
}

.van-card__header {
  padding: 1vh 0;
}

.van-card__bottom {
  line-height: 8.33333vw;
}

.van-card__num {
  float: left;
}

// .van-card {
//   background: #fff;
//   padding: 2.13333vw 2vw;
// }
.van-card {
  background: #fff;
  margin: 0 4.26667vw;
  padding: 4vw 0;
  // border-bottom: 1px solid #f7f7f7;
}

// .cardItem {
//   border-bottom: 1px solid rgb(244, 244, 244);
//   margin: 0 4.2vw;
// }
.van-panel__footer {
  padding: 3.13333vw 2vw;
}

.orderlist_foot {
  display: flex;
  height: 4.6vh;
  flex: 1;
  font-size: 14px;
  align-items: center;
  flex-wrap: wrap;
}

.ActualAmount {
  min-width: 30vw;
  padding-right: 5px;
}

[class*="van-hairline"]::after {
  border: none;
}
</style>
